// Este codigo fue generado por Github Copilot Chat
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent {
  @Input()
  src = '';

  @Input()
  uuid = '';

  @Input()
  name = '';

  @Input()
  label = '';

  @Input()
  icon = '';

  @Input()
  iconSecondary = '';

  @Input()
  border = false;

  @Output()
  clicked = new EventEmitter<string>();

  @Output()
  clickedAction = new EventEmitter<string>();

  toggleIcon = false;

  onClicked() {
    this.toggleIcon = !this.toggleIcon;
    this.clicked.emit(this.uuid);
  }

  getWords(name: string): string {
    if (!name) return '';
    const initials = name
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase())
      .join('');
    return initials.length > 2 ? initials.substring(0, 2) : initials;
  }

  onClickedAction() {
    this.clickedAction.emit(this.uuid);
  }
}
// Este codigo fue generado por Github Copilot Chat
